import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"

export default function DisclaimerRender({ renderPkg }:{ renderPkg?:any }){

  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata}

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "disclaimer").settings || {}
  const outerStyling = useRenderStyling("mm-section w-full pl-3", "styleObj")
  const contentStyling = useRenderStyling("leading-snug", "styleObj")
  
  const renderOpts:any = {
    standard_disclaimer_v1: `Please be advised that the documents above illustrate an example of the customer journey. Information in this document is based on data held by the merchant and publicly available sources. If the information contained herein is illegible or if additional information is required, please contact us via fax at +1 707-340-7609.`
  }


  return(
    <div id="mm-disclaimer" {...outerStyling}>
      <p {...contentStyling}>
        {renderOpts[settings.renderOption]}
      </p>
    </div>
  )
}